import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=e28f670e"
import script from "./SmsList.vue?vue&type=script&lang=js"
export * from "./SmsList.vue?vue&type=script&lang=js"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=e28f670e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports